<template>
  <section class="sme-container__info">
    <template>
      <div
        v-for="(item,index) in kycInfo"
        :key="index"
        class="box">
        <table
          class="table"
          :class="item.class" >
          <tr class="th font-14" >{{item.title}}</tr>
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.noShow"
            :key="sumIndex"
            class="tr"
            :class="{
              'tr-gray__title':sumItem.isAddress,
              'flex-start': sumItem.showValue2
            }"
          >
            <td class="fw-600">{{ sumItem.name }}</td>
            <td
              v-if="sumItem.type == 'array'"
            >
              <p
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum"
                class="color-dark">{{sum}}</p>
            </td>
            <td v-else-if="sumItem.isDocument">
              <v-upload
                v-for="(doc_item,index) in  sumItem.value"
                :key="'doc_item'+index"
                :card="true"
                :disabled="true"
                :fileData="doc_item"
              />
            </td>
            <td
              v-else-if="sumItem.value"
              v-copy="sumItem.value">
              {{sumItem.value}}
              <email-tooltip
                v-if="sumItem.name == 'Company Email'"
                :email="sumItem.value"></email-tooltip>
            </td>
            <td v-else-if="sumItem.value1" >
              <template v-if="!sumItem.showValue2">
                <div
                  v-copy="sumItem.value1"
                  :class="sumItem.className">
                  {{sumItem.value1}}
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(v2_item, v2_index) in sumItem.value2"
                  :key="v2_index"
                  :class="sumItem.className">
                  <template v-if="Array.isArray(v2_item)">
                    <p
                      v-for="(marketing, marketing_index) in marketingList"
                      :key="marketing_index"
                      v-copy="`${marketing.name}: ${getOptionName('consentOptions',v2_item.includes(marketing.id)?1:0)}`">
                      {{marketing.name}}: {{getOptionName('consentOptions',v2_item.includes(marketing.id)?1:0)}}
                    </p>
                  </template>
                  <template v-else>
                    <p v-copy="getOptionName('consentOptions', v2_item)">{{getOptionName('consentOptions', v2_item)}}</p>
                  </template>
                </div>
              </template>
            </td>
            <td
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </td>
          </tr>
        </table>
      </div>
    </template>
  </section>

</template>
<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'smeKycInfo',
  mixins: [MixinOptions],
  props: {
    classId:{
      type: Number,
      default: 81
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    showDocument:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      // compareData:
      marketingList: []
    }
  },
  computed: {
    smeFormData(){
      return this.formData||{}
    },
    smeOptions(){
      return this[`smeOptions${this.classId}`]||{}
    },
    policy_detail(){
      let {policy_detail={}} = this.smeFormData
      return policy_detail
    },
    insured_address(){
      let {insured_address={}} = this.policy_detail
      return insured_address||{}
    },
    other_info(){
      let {other_info={}} = this.smeFormData
      return other_info
    },
    showHour(){
      return [81,83,84,86,85,88].includes(this.classId)
    },
    showNature(){
      return [81,82,83,84,85,88].includes(this.classId)
    },
    showClasses(){
      return [85].includes(this.classId)
    },
    isNeed(){
      let need = [84,86,88].includes(this.classId)
      let {high_value_dev_ind} = this.other_info||{}
      return need&&high_value_dev_ind==1
    },
    showStock(){
      return [81,83,84,86,85,88].includes(this.classId)
    },
    isShowStock(){
      let {content_detail={}} = this.smeFormData||{}
      let {stocks_ind} = content_detail||{}
      return stocks_ind==1
    },
    showFire(){
      return [81,83,84,86,85,88].includes(this.classId)
    },
    showHigh(){
      return [84,86,88].includes(this.classId)
    },
    policyholder_detail(){
      let {policyholder_detail={}} = this.smeFormData
      return policyholder_detail
    },
    upload_document(){
      let {upload_document={}} = this.smeFormData
      return upload_document
    },
    corr_address(){
      let {corr_address={}} = this.policyholder_detail
      return corr_address
    },
    stockList(){
      let {bus_nature} = this.smeFormData.policy_detail||{}
      if(this.classId==83){
        let {kind_of_stock={}} = this.smeOptions
        return kind_of_stock[`bus_nature_${bus_nature}`]
      }
      return this.smeOptions.kind_of_stock
    },
    kycInfo(){
      let {marketing_data} = this.smeFormData||{}
      let {is_use,use_data,other_use} = marketing_data||{}
      let arr =  [
        {
          title: 'Policy Details',
          class:'mg-b-10',
          list:
            [
              {
                name: 'Expected Effective Date',//pure,
                value:this.policy_detail.pcy_cmnt_dt,
              },
              {
                name: 'Is your Insured Address / Place of Employment same as Correspondence Address?',//pure,
                value:this.getOptionName('smeYesNoOptions',this.policy_detail.same_as_corr_addr_ind),
              },
              {
                name: 'Insured Address / Place of Employment',
                isAddress:true
              },
              {
                name: 'Room',
                value:this.insured_address.addr_room,
              },
              {
                name: 'Floor',
                value:this.insured_address.addr_block,
              },
              {
                name: 'Block',
                value:this.insured_address.addr_building,
              },
              {
                name: 'Building / Estate',
                value:this.insured_address.addr_building,
              },
              {
                name: 'District',
                value:this.getAreaName('district', this.insured_address.addr_district)
              },
              {
                name: 'Area',
                value:this.getAreaName('area', this.insured_address.addr_area)
              },
              {
                name: 'Country / Region',
                value:this.getAreaName('region', this.insured_address.addr_region)
              },
              {
                name: 'Business Nature',
                value:this.getSMEOptionName(this.smeOptions.business_nature,this.policy_detail.bus_nature),
                noShow:!this.showNature
              },
              {
                name: 'Business Hour',
                value:this.policy_detail.bus_hour_nm||this.policy_detail.bus_hour,
                noShow:!this.showHour
              },
              {
                name: 'Class Session',
                value:this.getSMEOptionName(this.smeOptions.classes,this.policy_detail.classes_id),
                noShow:!this.showClasses
              },
              {
                name: 'No. of participants per class?',
                value:this.getSMEOptionName(this.smeOptions.number_per_class,this.policy_detail.no_per_class),
                noShow:!this.showClasses
              },
            ]
        },
        {
          title: 'Policyholder Details',
          isBold:true,
          list: [
            {
              name: 'Company Name',
              value: this.policyholder_detail.isrd_com_nm,
            },
            {
              name: 'Business Registration Number',
              value: this.policyholder_detail.id_no,
            },
            {
              name: 'Company Phone No.',
              value: this.policyholder_detail.phone_no,
            },
            {
              name: 'Company Email',
              value: this.policyholder_detail.email,
            },
            {
              name: 'Contact Person Name',
              field: 'contact_nm',
              value: this.policyholder_detail.contact_nm,

            },
            {
              name: 'Contact Person Mobile No..',
              field: 'contact_phone',
              value: this.policyholder_detail.contact_phone,
            },
            {
              name: 'Company Address',
              isAddress:true
            },
            {
              name: 'Room',
              value:this.corr_address.addr_room,
            },
            {
              name: 'Floor',
              value:this.corr_address.addr_block,
            },
            {
              name: 'Block',
              value:this.corr_address.addr_building,
            },
            {
              name: 'Building / Estate',
              value:this.corr_address.addr_building,
            },
            {
              name: 'District',
              value:this.getAreaName('district', this.corr_address.addr_district)
            },
            {
              name: 'Area',
              value:this.getAreaName('area', this.corr_address.addr_area)
            },
            {
              name: 'Country / Region',
              value:this.getAreaName('region', this.corr_address.addr_region)
            },
          ],
        },
        {
          title: 'Direct Marketing Consent',
          isSpan: true,
          list: [
            {
              name: 'Marketing Consent',
              value1: this.getOptionName('consentOptions', is_use),
              showValue2: is_use === 0,
              value2: [is_use, use_data,other_use],
              className: 'marketing'
            }
          ]
        },
        {
          title:'Other Information',
          isSpan:true,
          list:[
            {
              name:'What kind of stock?',
              // value:this.getSMEOptionName(this.stockList,this.other_info.kinds_of_stocks),
              value:this.other_info.kinds_of_stocks_nm,
              noShow:!this.isShowStock,
              type:'array'
            },
            {
              name:'Max. value per consumer packing',
              value:this.other_info.max_val_per_stocks,
              noShow: !this.isShowStock
            },
            {
              name:'Is there any beauty device(s) valued over HK$100,000?',
              value:this.getOptionName('smeYesNoOptions',this.other_info.high_value_dev_ind),
              noShow: !this.showHigh
            },
            {
              name:'Total sum insured of the beauty device(s) (over HK$100,000 per unit/set)',
              value:this.other_info.high_value_dev_isrd,
              noShow:!this.showHigh
            },
            {
              name:'Is a burglary alarm installed in your premises?',
              value:this.getOptionName('smeYesNoOptions',this.other_info.alarm_install_ind),
            },
            {
              name:'Please provide details of the burglary alarm system installed in your premises.',
              value:this.other_info.alarm_detail,
            },
            {
              name:'Any sprinkler or fire extinguisher system?',
              value:this.getOptionName('smeYesNoOptions',this.other_info.fire_sprinkler_ind),
              noShow: !this.showFire
            },
            {
              name:'Work in/on or visiting construction sites, ships, shipyards, chemical works, off-shore structures, oil or gas refineries?',
              value:this.getOptionName('smeYesNoOptions',this.other_info.wk_in_danger_pos_ind)
            },
            {
              name:'Work over 30 feet or work underground?',
              value:this.getOptionName('smeYesNoOptions',this.other_info.wk_in_high_ind)
            },
            {
              name:'Work outside Hong Kong?',
              value:this.getOptionName('smeYesNoOptions',this.other_info.wk_outside_hk_ind)
            },
            {
              name:'Use, handle, store or transport any hazardous substances such as toxic chemicals, explosive substances, gases, asbestos, radioactive substances?',
              value:this.getOptionName('smeYesNoOptions',this.other_info.use_hazardous_ind)
            },
            {
              name:'Do you plan to increase the number of the employees substantially or add different occupations in a short period of time?',
              value:this.getOptionName('smeYesNoOptions',this.other_info.incr_employee_ind)
            },
            {
              name:'Has your company or employees had any previous loss, damage or injury covered by this Plan in the past 3 years?',
              value:this.getOptionName('smeYesNoOptions',this.other_info.prev_loss_ind)
            },
          ]
        },
      ]
      if(this.showDocument){
        let document_arr = [
          {
            title:'Upload Document',
            isSpan:true,
            list:[
              {
                name:'Business Registration Certificate',
                value:this.upload_document.device_files,
                isDocument:true
              },
              {
                name:'The latest 3 months of MPF Contribution Record',
                value:this.upload_document.br_files,
                isDocument:true
              },
              {
                name:'The latest 3 months of MPF Contribution Record',
                value:this.upload_document.renewal_files,
                isDocument:true
              },
              {
                name:'List of  machines / devices to be insured (valued over HK$100,000 per item/set)',
                value:this.upload_document.device_files,
                isDocument:true,
                noShow: !this.showHigh
              },
            ]
          }
        ]
        arr = [...arr,...document_arr]
      }
      return arr
    }
  },
  watch:{
    specialOptions:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.marketing_data){
          let arr = JSON.parse(JSON.stringify(val.marketing_data)) || []
          this.marketingList = arr
        }
      }
    },
  },

  methods: {
    showCompare(item, field) {
      var change = field
      return change
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../info";
/deep/.upload-container{
  width: 320px!important;
  .upload-card {
    width: 320px;
    height: 150px;
  }
}
.flex-start{
  align-items: flex-start !important;
}
.marketing + .marketing{
  margin-top: 10px;
}
</style>
